import { Spinner } from '../components/spinner.js';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { chooseAthlete, useAthleteSearch, useChosenAthlete } from '../api/coach-booking.js';
import { ChosenAthlete } from '../components/chosen-athlete.js';
import { NewAthleteForm } from '../components/new-athlete-form.js';
import { BookingRoute } from './booking-route.js';
import { SearchFeedback } from '../components/search-feedback.js';

/**
 * The MPC coach's Book tab (stage B; canvas row 10, approved 16 October).
 *
 * First who it is for - anyone in the system, by name, each with the year of
 * birth and the parent's name so two of one name can be told apart. Then the
 * parent's own calendar, under "Athlete · Noa Park" with Change; no cart, so
 * the cart's strip and button are left out.
 *
 * Add a new athlete (stage C; canvas row 11) is always under the search -
 * one screen to find or add (Matthew, 25 October) - and takes what is typed:
 * the athlete's and the parent's names and the parent's email, then the same
 * calendar. An athlete a coach added has no year of birth until the parent
 * gives it, so their row shows the parent alone.
 *
 * From Clients → a family with several athletes → Book a lesson, the search
 * opens on the family's name, to pick which (21 October).
 *
 * The search shows it is searching, and an empty one says No matches for
 * what was typed (RE-35, 27 October).
 */
export function CoachBookRoute() {
  const athlete = useChosenAthlete();
  const opened = useLocation().state as { search?: string } | null;
  const [query, setQuery] = useState(opened?.search ?? '');
  const [adding, setAdding] = useState(false);
  const { matches, searching } = useAthleteSearch(query);

  if (athlete) {
    return (
      <>
        <ChosenAthlete name={athlete.name} />
        <BookingRoute showCart={false} />
      </>
    );
  }

  if (adding) return <NewAthleteForm firstGuess={query} onBack={() => setAdding(false)} />;

  return (
    <>
      <div className="field">
        <label htmlFor="booking-for">Search for an athlete or add</label>
        <span className="search-box">
          <input
            id="booking-for"
            type="search"
            value={query}
            autoComplete="off"
            autoCapitalize="words"
            onChange={(event) => setQuery(event.target.value)}
          />
          {searching ? <Spinner /> : null}
        </span>
      </div>
      <SearchFeedback query={query} searching={searching} found={matches.length} />
      {matches.map((match) => (
        <button key={match.client_id} type="button" className="hour-row" onClick={() => chooseAthlete(match)}>
          <span className="hour-row-text">
            <span className="name">{match.name}</span>
            {match.birth_year || match.parent_name ? (
              <span className="detail">
                {[match.birth_year ? `Born ${match.birth_year}` : null, match.parent_name].filter(Boolean).join(' · ')}
              </span>
            ) : null}
          </span>
          <span className="chevron" aria-hidden="true">
            ›
          </span>
        </button>
      ))}
      <button type="button" className="secondary" onClick={() => setAdding(true)}>
        Add a new athlete
      </button>
    </>
  );
}
